import styled from "styled-components";
// import palette from "../../lib/styles/palette";
import Button from "../common/Button";

const StructureEstimateActionButtonsBlock = styled.div`
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    margin-top: 5rem;
    margin-bottom: 5rem;
    padding: 0 1rem;
    // display: flex;
    // justify-content: flex-end;
`;

const StyledButton = styled(Button)`
    height: 2.125rem;
    & + & {
        margin-left: 0.5rem;
    }
`;

const StructureEstimateActionButtons = ({ isEdit, onPublish, onCancel }) => {

    return (
        <StructureEstimateActionButtonsBlock>
            <StyledButton cyan onClick={onPublish}>Structure {isEdit ? '수정' : '등록'}</StyledButton>
            <StyledButton onClick={onCancel}>취소</StyledButton>
        </StructureEstimateActionButtonsBlock>
    );
};

export default StructureEstimateActionButtons;